export const PersonTitles = [
    'Dr.',
    'Prof.',
    'Prof. Dr.',
    'Mag.'
];
